import React from 'react';
import {Grid, GridCol} from '@flixbus/honeycomb-react';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import ReadOnlyInput from '@/components/ReadOnlyInput/ReadOnlyInput';
import {useReadOnlyKpiInputConfigBuilder} from '../hooks/useReadOnlyKpiInputConfigBuilder';
import {ProductionCostKpisConfig} from './ProductionCostKpisList.data';

const ProductionCostKpisList: React.FC = () => {
  const kpis = useAppSelector(({productionCost}) => productionCost.kpis);
  const inputs = useReadOnlyKpiInputConfigBuilder(
    kpis ?? null,
    ProductionCostKpisConfig
  );

  if (!inputs.length) return null;

  return (
    <Grid>
      {inputs.map(input => (
        <GridCol size={3} key={input.id}>
          <ReadOnlyInput
            extraClasses="content-secondary-color"
            horizontal
            {...input}
          />
        </GridCol>
      ))}
    </Grid>
  );
};

export default React.memo(ProductionCostKpisList);
